import { NumberInput, required, useTranslate } from 'react-admin';
import { Box, Stack, Typography } from '@mui/material';
import { RedPacketConfig } from '../../../services/redpacketService';

interface FormProps {
  isCreate: boolean;
  record?: RedPacketConfig;
}


const WithdrawConfigForm = (props: FormProps) => {
  const { isCreate, record } = props;
  const t = useTranslate();

  const numberProps = {
    parse: (v: any) => (v === '' || v == null ? undefined : Number(v)),
    format: (v: any) => (v == null ? '' : v),
    inputProps: {
      inputMode: 'decimal',
      step: 'any',
      onWheel: (e: React.WheelEvent<HTMLInputElement>) => {
        (e.currentTarget as HTMLInputElement).blur();
      },
    } as const,
  } as const;

  const label = record?.configKey;

  return (
    <Stack spacing={3} gap={2}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {label}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <NumberInput
            label={false}
            source="value"
            validate={[required()]}
            placeholder={label}
            fullWidth
            defaultValue={record?.value}
            {...numberProps}
          />
        </Box>
      </Stack>
    </Stack>
  );
};

export default WithdrawConfigForm;
